import IdColumn from './IdColumn';
import NameColumn from './NameColumn';
import StatusColumn from './StatusColumn';
import EndDateColumn from "./EndDateColumn";
import PreviewColumn from "./PreviewColumn";
import StartDateColumn from "./StartDateColumn";
import ActiveProductsColumn from "./ActiveProductsColumn";
import PriorityColumn from "./PriorityColumn";
import RenderStatusColumn from "./RenderStatusColumn";

// Column renderer factory
const createTemplateColumnRenderers = () => ({
  'id': (props) => <IdColumn {...props} />,
  'name': (props) => <NameColumn {...props} />,
  'priority': (props) => <PriorityColumn {...props} />,
  'preview': (props) => <PreviewColumn {...props} />,
  'active_products': (props) => <ActiveProductsColumn {...props} />,
  'start_date': (props) => <StartDateColumn {...props} />,
  'end_date': (props) => <EndDateColumn {...props} />,
  'status': (props) => <StatusColumn {...props} />,
  'render_status': (props) => <RenderStatusColumn {...props} />,
});

export {
  IdColumn,
  NameColumn,
  PreviewColumn,
  ActiveProductsColumn,
  StartDateColumn,
  EndDateColumn,
  StatusColumn,
  PriorityColumn,
  RenderStatusColumn,
  createTemplateColumnRenderers
};
